import React from 'react';
import { LANDING_URL } from '../lib/service-registry';

interface AccessDeniedViewProps {
  onGoBack: () => void;
  reason?: string;
}

/**
 * TSCORP-437: Unified access-denied view across all services.
 * GCP Material Light design system.
 */
const AccessDeniedView: React.FC<AccessDeniedViewProps> = ({ onGoBack, reason }) => {
  const isUnregistered = reason === 'unauthorized_email' || reason === 'no_organization';

  return (
    <div className="access-denied-container">
      <div className="access-denied-icon-circle">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d93025" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <h2 className="access-denied-title">
        {isUnregistered ? '등록되지 않은 사용자입니다' : '접근 권한이 없습니다'}
      </h2>
      <p className="access-denied-message">
        {isUnregistered
          ? '시스템에 등록되지 않은 계정입니다. IT 관리자에게 접근 권한을 요청하세요.'
          : '이 페이지를 볼 수 있는 권한이 없습니다. 관리자에게 문의하세요.'}
      </p>

      {/* IT Support contact */}
      <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '12px 16px', marginBottom: '16px' }}>
        <p style={{ fontSize: '11px', color: '#80868b', textTransform: 'uppercase', letterSpacing: '0.025em', marginBottom: '4px' }}>IT Support</p>
        <a href="mailto:it@tscorp.ai" style={{ fontSize: '14px', color: '#1a73e8', textDecoration: 'none' }}>
          it@tscorp.ai
        </a>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
        <button onClick={onGoBack} className="ts-btn ts-btn-primary" style={{ width: '100%', maxWidth: '280px' }}>
          대시보드로 돌아가기
        </button>
        <a href={LANDING_URL} style={{ fontSize: '14px', color: '#1a73e8', textDecoration: 'none' }}>
          TSCORP 포털로 돌아가기
        </a>
      </div>
    </div>
  );
};

export default AccessDeniedView;
